// extracted by mini-css-extract-plugin
export default {"paymentSummary":"oeWYbvM","price":"AyNW5sf","notification":"a2g0CO6","vatCaption":"gn7dkZJ"};